import { Component } from "react"
import PropTypes from "prop-types"
import Cookies from "js-cookie"
import parse from "html-react-parser"

export default class PartnerUpdates extends Component {
  constructor(props) {
    super(props)

    this.state = {
      display: props.display,
    }

    this.onHideNotice = this.onHideNotice.bind(this)
  }

  onHideNotice() {
    this.setState({ display: false })
    this.markAsRead()
  }

  markAsRead() {
    let domain = window.location.hostname
    let parts = domain.split(".").slice(-2)

    // prepending an empty string to our domain makes this a global cookie
    // that can be shared accross all subdomains
    domain = [""].concat(parts).join(".")

    Cookies.set("partners_update_version", this.props.version, {
      domain,
      expires: 365,
    })
  }

  render() {
    if (!this.state.display) {
      return <div />
    }

    return (
      <div className="partners-update">
        <div>{parse(this.props.content)}</div>
        <div
          className="hide"
          title="Hide this notice"
          onClick={this.onHideNotice}
        />
      </div>
    )
  }
}

PartnerUpdates.propTypes = {
  display: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
}
